/**
 * Map of products and environments to their Amplitude API keys.
 *
 * Anything that is not prod is test as far as Amplitude is concerned.
 */

export const world = {
  tigers: {
    prod: {
      analytics: '',
      experiment: ''
    },
    test: {
      analytics: 'ced15b84716624011304f2ccb8476641',
      experiment: 'client-GC0smzdsVBK8s2bEsHEe4HkFeuHNeyub'
    }
  },
  research: {
    prod: {
      analytics: '35b3a5d73ca8eb9dbb84f61ed699e614',
      experiment: 'client-kdCXBOQAxys8MGX68DAvRV3fLNcvXEpr'
    },
    test: {
      analytics: '232c4d9702fa4c9c0bea7626b598b4d7',
      experiment: 'client-7SJKDjOBonEL8lIX0LcWmGQMWA4XcDow'
    }
  },
  fdtvplus: {
    prod: {
      analytics: '5f28b5b35b534df2d950776d001de5e7',
      experiment: 'client-3kAQHTcruJeXDbQQyiyzahsk0ze4rK0U'
    },
    test: {
      analytics: '597fb08dc19b5f0a234f471f43416c6c',
      experiment: 'client-eEFuqjW3urlxTSwXoUDiCagSNE7XAixw'
    }
  },
  dfs: {
    prod: {
      analytics: 'ef7268ea6d07bc3ff8b1dceb7de322de',
      experiment: 'client-Io3gfUqzOGbTeIUlj1gttD3ZMZwVJ0Va'
    },
    test: {
      analytics: 'c329d6183666439fd04ce4af3ae27547',
      experiment: 'client-EMYX0H7LomislGHov9d2Z4BG86Iyf1t5'
    }
  },
  cms: {
    prod: {
      analytics: 'e9867ea3d11ed08ffc8ab0494d9dcffb',
      experiment: 'client-PRh7kS5jrLiGge8TT4VZtrrCoccfgV04'
    },
    test: {
      analytics: '1b469afc8aae14698727fc7f2d5c7945',
      experiment: 'client-xhh9rSMROHYV8fDql5hAFoGdJuQWkiIr'
    }
  },
  skilledGames: {
    prod: {
      analytics: '8ffbf28fb669beb7fc9068a123888d3a',
      experiment: 'client-iRroNlgoeR6qssGLDX2r7U3WrcICPPq3'
    },
    test: {
      analytics: '6fac655769a17a3b47586fc19efbf296',
      experiment: 'client-8VRIZC8yws84oMjNLEFykLNjRkFpYh18'
    }
  },
  racing: {
    prod: {
      analytics: '7a02b3ee70357df0fedb2f073ee6b9d0',
      experiment: 'client-UxgLTJk47Cc6ce5aUb7gcwUvH1tCcDSp'
    },
    test: {
      analytics: '4a003fec5c6b5c9075661fd874943089',
      experiment: 'client-sJeHwbwoOdpgTjlausdjWW5szEQK3PMG'
    }
  },
  sportsbookTest: {
    prod: {
      analytics: '45a44d86689c08b97f182eb1a0fee941',
      experiment: 'client-2AoBJBe4SSV86GM9CjsQYFiI2Oi50S9W'
    },
    test: {
      analytics: '45a44d86689c08b97f182eb1a0fee941',
      experiment: 'client-2AoBJBe4SSV86GM9CjsQYFiI2Oi50S9W'
    }
  },
  internalTools: {
    prod: {
      analytics: '4fd7de7fe2ec95ed98699bdd65f906d4',
      experiment: 'client-6YLgkDENRfWLzfGAL2nnCXlPbjz3sbo6'
    },
    test: {
      analytics: '2784ffe787872328b283e74fce2cffe4',
      experiment: 'client-Qb3ljlsOv3DOWnGdA2Bh6suuN1Gdsy3d'
    }
  }
};
export const usa = {
  casino: {
    prod: {
      analytics: '37bc6a03c048c47939a6ffb7b7ef9fc3',
      experiment: 'client-qF2JWmO3qGgVjn2G6jcMIJZGexa4uSrY'
    },
    test: {
      analytics: 'dfdfab544c67bf254b525c7e3928cffa',
      experiment: 'client-bBg3z4xwX33bFMQJ7rUxhat1jgECTXWm'
    }
  },
  sportsbook: {
    prod: {
      analytics: 'e23053be3d840ae45b2a1f786ba058f3',
      experiment: 'client-D2sDlsaor1uJBVVUsocdIkZcEgMvTJag'
    },
    test: {
      analytics: '64d1bda80ee432dabc671f9f8e7ec563',
      experiment: 'client-qwNNK7O5hNSY7kbMjiqntql4nxu9DuIA'
    }
  }
};
export const canada = {
  casino: {
    prod: {
      analytics: 'a3285c8d687b09fdd8c13fdfb0a6975c',
      experiment: 'client-eVZHXYcRWp0lo75p3QLGDZxP5k1wABF4'
    },
    test: {
      analytics: 'd52051214165cbd260e45c5dda1956cf',
      experiment: 'client-pdox4BDw09tZnj6zrn9zF0vvLQZCEhoX'
    }
  },
  sportsbook: {
    prod: {
      analytics: 'ecfd9d25959c777243613ec759194944',
      experiment: 'client-kMikWZ6xA6wKnS5Ye8LCrIp8Puu2GH1g'
    },
    test: {
      analytics: '0e7d4f2fc239f5f8a4746102472d97a0',
      experiment: 'client-oLIYsdfzKhUgJh1IUskTEGEh3MjZaKvI'
    }
  }
};
export const deploymentsGlobal = {
  casino: {
    'cpe-web': {
      prod: 'client-qF2JWmO3qGgVjn2G6jcMIJZGexa4uSrY',
      test: 'client-sy1BkE53lX0vvuBuIzI5yqEDP561ipBB'
    }
  },
  dfs: {
    'cpe-web': {
      prod: 'client-u4rcBBbtfiOgNAFb0rUvHbZfodQKaFQ0',
      test: 'client-N6HqTTgEhSj05LJermHGUTIgOV4DZRM6'
    }
  },
  skilledGames: {
    'cpe-web': {
      prod: 'client-iRroNlgoeR6qssGLDX2r7U3WrcICPPq3',
      test: 'client-8VRIZC8yws84oMjNLEFykLNjRkFpYh18'
    }
  },
  racing: {
    'cpe-web': {
      prod: 'client-UxgLTJk47Cc6ce5aUb7gcwUvH1tCcDSp',
      test: 'client-sJeHwbwoOdpgTjlausdjWW5szEQK3PMG'
    }
  },
  sportsbook: {
    'cpe-web': {
      prod: 'client-5xlIVGL8e7Nfnt2H6wIgLm7p8Ked2VTH',
      test: 'client-YA2sGyaXthgkCAsBCEbrx4OD6Oy02ItY'
    }
  }
};
export const deploymentsUs = {
  casino: {
    'cpe-web': {
      prod: 'client-qF2JWmO3qGgVjn2G6jcMIJZGexa4uSrY',
      test: 'client-sy1BkE53lX0vvuBuIzI5yqEDP561ipBB'
    },
    'raf-web': {
      prod: 'client-GXdPF7pfFTa3COSWtKBGDeamptM1DARw',
      test: 'client-dLct6vT1eNkNUc8roewFo1nkKaI6P6u3'
    }
  },
  sportsbook: {
    'cpe-web': {
      prod: 'client-5xlIVGL8e7Nfnt2H6wIgLm7p8Ked2VTH',
      test: 'client-YA2sGyaXthgkCAsBCEbrx4OD6Oy02ItY'
    },
    'raf-web': {
      prod: 'client-Z740egL9xF50fSTLQGFVKMWpV80xwhuc',
      test: 'client-qEZTxtHFkLFmPr6ccoP0laY8rqvXCldH'
    }
  }
};
export const deploymentsCanada = {
  casino: {
    'cpe-web': {
      prod: 'client-9Nn1xhdYQCAn1SHTp3MoOhs120XAoV6W',
      test: 'client-rPJ75s5LdodPeapPNZvsYVab8V3OatXk'
    },
    'raf-web': {
      prod: 'client-gWLGAf9FGqGh7BMLmGrNDRoYZDfnCuaS',
      test: 'client-Gi1YdO2FoV37pf0Xf75r0YGubcxYTdkR'
    }
  },
  sportsbook: {
    'cpe-web': {
      prod: 'client-AarsgsE5ddAfaiEsufoTsGFNu2cUw0JX',
      test: 'client-bSDEAmkJXSiVOLRPPnBs4tHhS6ZiHfoz'
    },
    'raf-web': {
      prod: 'client-aX3loisenMdxSFK0nZw9VuhgE3tk4kNu',
      test: 'client-8wjG53fZXkxpQicWxM4X8xENAn5eibqc'
    }
  }
};
export default {};
//# sourceMappingURL=amplitude_environments.js.map